
export interface AssignInvoiceCriteriaEntity {
    billToCompanys?: string[] | null,
    tariffTypes?: string[] | null,
    chargeTypes?: string[] | null,
    subChargeTypes?: string[] | null,
    containerStatus?: string[] | null,
    containerSizes?: string[] | null,
    shipmentTypes?: string[] | null,
    customerCodes?: string[] | null,
    docDateFrom: Date | null,
    docDateTo: Date | null,
    opsDateFrom: Date | null,
    opsDateTo: Date | null,
    glDateFrom: Date | null,
    glDateTo: Date | null,

    [key: string]: string[] | Date | null | undefined
}

export const EMPTY_ASSIGN_INVOIC_CRITERIA_ENTITY: AssignInvoiceCriteriaEntity = {
    billToCompanys: [],
    tariffTypes: [],
    chargeTypes: [],
    subChargeTypes: [],
    containerStatus: [],
    containerSizes: [],
    shipmentTypes: [],
    customerCodes: [],
    docDateFrom: null,
    docDateTo: null,
    opsDateFrom: null,
    opsDateTo: null,
    glDateFrom: null,
    glDateTo: null,
}